import React from 'react'
import { Card, Typography, Button, Space } from 'antd'
import { CalendarOutlined, VideoCameraOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { handleClinicBooking, handleVirtualConsult } from '../../../../../Bookings/utils/lib'
import { CARD_STYLES } from '../utils/constants'

const { Title } = Typography

const QuickActionsCard = () => {
  const dispatch = useDispatch()
  const entityState = useSelector((state) => state.core.entity)

  return (
    <Card
      bordered={false}
      style={{
        boxShadow: CARD_STYLES.shadow,
        borderRadius: CARD_STYLES.borderRadius,
        textAlign: 'center',
        height: '100%'
      }}
    >
      <Title level={4} style={{ marginBottom: '24px' }}>
        Quick Actions
      </Title>
      <Space direction='vertical' size='large' style={{ width: '100%' }}>
        <Button
          type='primary'
          icon={<CalendarOutlined />}
          size='large'
          block
          onClick={() => handleClinicBooking(false, dispatch)}
        >
          Schedule In-Person Visit
        </Button>
        {entityState.virtualConsultations.enabled && (
          <Button
            type='primary'
            icon={<VideoCameraOutlined />}
            size='large'
            block
            onClick={() => handleVirtualConsult(false, dispatch)}
          >
            Schedule Virtual Consult
          </Button>
        )}
      </Space>
    </Card>
  )
}

export default QuickActionsCard
